export default "__VITE_ASSET__3c0291e4__"